import makeStyles from '@mui/styles/makeStyles'
import { MyAccountTheme, MaLoginClasses } from '@dxp-module/themes'

const loginStyles = makeStyles<MyAccountTheme, object, MaLoginClasses>(
  ({ breakpoints }) => ({
    root: {},
    container: {},
    loginModule: {
      margin: '0 auto',
      [breakpoints.down('sm')]: {
        margin: '10px',
      },
      maxWidth: '600px',
      padding: '20px 0',
    },
    layoutContainer: {},
  }),
  { name: 'MyAccount_Login' }
)

export default loginStyles
